"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  root: {
    fontSize: '1rem'
  },
  colorDefault: {
    backgroundColor: '#edf1f3',
    color: '#3d464b'
  }
};
exports["default"] = _default;